module.exports = __webpack_public_path__ + "static/media/logo-cms-on.22d3c3e0.svg";